import React, { FC, useEffect, useState } from 'react';
import { Formik, FormikHelpers, FormikValues, Form } from 'formik';
import { Box, Button, Stack, Switch, Typography } from '@mui/material';
import * as yup from 'yup';
import toast from 'react-hot-toast';
import { FieldText } from '../../../../components/fields/Text/Text';
import axiosInstant from '../../../../api';
import { updateVideoSettingsEndpoint } from '../../../../api/endpoints';

const videoSettingsSchema = yup.object().shape({
  name: yup.string().required(),
});

interface Props {
  brandId: number;
  videoId: number;
  onComplete: (data: any) => void;
  name: string;
  published_public: boolean;
}

export const SettingsForm: FC<Props> = ({ brandId, videoId, name, published_public, onComplete }) => {
  const [publishedValue, setPublishedValue] = useState(published_public);
  const [initialValues, setInitValues] = useState({ name, published_public });

  const handleSubmit = async (values: FormikValues, { setSubmitting }: FormikHelpers<typeof initialValues>) => {
    const payload = { name: values.name, brandId, published: publishedValue };
    const updateVideoUrl = updateVideoSettingsEndpoint(videoId);
    if (updateVideoUrl) {
      try {
        const response = await axiosInstant.patch(updateVideoUrl, payload);
        const { status } = response;
        if (status === 200) {
          toast.success(`Video ${values.name} settings has been updated.`);
          onComplete(payload);
        } else toast.error(`Some error encountered.`);
      } catch (error) {
        toast.error(`Some error encountered.`);
      }
    }

    // always setSubmitting false at the end of the function
    setSubmitting(false);
  };

  const handlePublishedChange = async (e: any) => {
    setPublishedValue(e.target.checked);
  };

  useEffect(() => {
    setInitValues({ name, published_public });
    setPublishedValue(published_public);
  }, [name, published_public]);

  return (
    <Formik initialValues={initialValues} enableReinitialize validationSchema={videoSettingsSchema} onSubmit={handleSubmit}>
      <Form>
        <Stack width={1} spacing={4}>
          <Stack width={1} spacing={1}>
            <FieldText name="name" label="Name" size="small" placeholder="Name" fullWidth />
          </Stack>
          <Stack direction="row" spacing={10} alignItems="center">
            <Stack direction="row" spacing={1} alignItems="center">
              <Switch checked={publishedValue} onChange={handlePublishedChange} />
              <Typography>Published</Typography>
            </Stack>
          </Stack>
        </Stack>
        <Box marginTop={5}>
          <Button size="large" type="submit" variant="contained" disableElevation>
            Submit
          </Button>
        </Box>
      </Form>
    </Formik>
  );
};
